import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logoImg from '../assets/logo.png';

export default function AuthCallback() {
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }

      const result = await handleGoogleCallback(sessionId);

      if (result.success) {
        window.history.replaceState(null, '', window.location.pathname);

        if (result.data.profile_completed) {
          navigate('/feed', { replace: true });
        } else {
          // Usuario nuevo con Google — debe aceptar términos primero
          navigate('/accept-terms', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen bg-[hsl(35,25%,91%)] flex flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-1 mb-8">
        <img src={logoImg} alt="Partykatu" className="h-12 w-auto" />
        <span className="font-heading font-semibold text-xl text-[hsl(144,18%,38%)] tracking-tight" translate="no">Partykatu</span>
      </div>
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[hsl(144,18%,45%)]"></div>
      <p className="mt-4 text-gray-600">Verificando tu cuenta...</p>
    </div>
  );
}
